<template>
  <div class="text-xs-center">
    <v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular>
  </div>
</template>

<script>
  import {Auth} from './cognito_auth';

  export default {
    name: 'LoginCallback',
    created () {
      Auth.handleLogingResponseFromIDP();
      this.$router.replace({path: '/app/audio_generator'});
    }
  }
</script>
